<template>
  <div>
    <ring-loader v-show="loading"/>
    <div v-show="!loading" class="row">
      <div class="row margin-bottom-20">
        <div class="col-md-12">
          <div class="form-group col-md-3">
            <label class="control-label">
              {{ 'fiscalization_report.date_from' | trans }}
            </label>
            <date-picker
                v-model="dateFrom"
                :time=false
                :is-nullable="false"
            />
          </div>
          <div class="form-group col-md-3">
            <label class="control-label">
              {{ 'fiscalization_report.date_to' | trans }}
            </label>
            <date-picker
                v-model="dateTo"
                :time=false
                :is-nullable="false"
            />
          </div>
          <div class="form-group col-md-3">
            <label class="control-label">
              {{ 'fiscalization_report.brand' | trans }}
            </label>
            <single-select
                v-model="brand"
                :checked="brand"
                :options="brands"
                :allow-empty="false"
                class="brand-multiselect"
            />
          </div>
          <div class="form-group col-md-3">
            <label class="control-label col-md-12">&nbsp;</label>
            <button class="btn btn-success" @click="getReport">
              {{ 'fiscalization_report.download' | trans }}
            </button>
          </div>
        </div>
      </div>
      <div v-show="errors.length" class="row">
        <div class="col-md-12">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              <strong>{{ 'fiscalization_report.error' | trans }}:</strong>
              <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from '@component/datePicker.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import SingleSelect from '@component/singleselect.vue'
import axios from 'axios'

export default {
  name: 'FiscalizationReport',
  components: {
    SingleSelect,
    DatePicker,
    RingLoader
  },
  data() {
    return {
      loading: 1,
      dateFrom: new Date(),
      dateTo: new Date(),
      brand: null,
      brands: [],
      errors: []
    }
  },
  watch: {
    dateTo(value) {
      if (value < this.dateFrom) {
        this.dateFrom = new Date(value)
      }
    },
    dateFrom(value) {
      if (value > this.dateTo) {
        this.dateTo = new Date(value)
      }
    }
  },
  mounted() {
    this.getBrands()
    this.loading--
  },
  methods: {
    async getReport() {
      this.loading++
      this.errors = []

      await axios.get(
        Routing.generate('api_fiscalization_report', {
          brandId: this.brand,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        }),
        { responseType: 'blob' }
      ).then(response => {
        this.downloadFile(response)
        this.loading--
      }).catch(({ response }) => {
        response.data.text().then(error => {
          this.errors = JSON.parse(error)
        })
        this.loading--
      })
    },
    downloadFile(response) {
      const link = document.createElement('a')
      link.href = URL.createObjectURL(response.data)
      link.download = response.headers['content-disposition'].match(/filename="(.*)"$/)[1]
      link.target = '_blank'
      link.click()
    },
    getBrands() {
      this.loading++

      this.$http.get(Routing.generate('api_get_brands', { context: 'dropdown' }))
        .then(response => {
          this.brands = response.data.filter(brand => brand.isProduction)
          this.brand = this.brands[0].id
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
    },
  }
}
</script>

<style>
.brand-multiselect > .multiselect {
  min-height: unset;
}

.brand-multiselect > .multiselect > .multiselect__tags {
  min-height: unset;
  padding: 6px 40px 0 8px;
  border: 1px solid #ccc;
}
</style>